module.exports = __webpack_public_path__ + "img/en-8d4574.png";